<template>
  <div class="swiper" ref="swiperContainer">
    <div class="swiper-wrapper">
      <div
        v-for="(image, index) in images"
        :key="index"
        class="swiper-slide"
        :style="{ backgroundImage: `url('${image.src}')` }"
        :aria-label="`Gallery slide ${index + 1}`"
      ></div>
    </div>
    <button class="swiper-button-prev" aria-label="Previous slide">
      <svg width="36px" height="36px" viewBox="0 0 48 48" fill="currentColor">
        <path d="M30.83 32.67l-9.17-9.17 9.17-9.17L28 11.5l-12 12 12 12z"></path>
        <path d="M0-.5h48v48H0z" fill="none"></path>
      </svg>
    </button>
    <button class="swiper-button-next" aria-label="Next slide">
      <svg width="36px" height="36px" viewBox="0 0 48 48" fill="currentColor">
        <path d="M17.17 32.92l9.17-9.17-9.17-9.17L20 11.75l12 12-12 12z"></path>
        <path d="M0-.25h48v48H0z" fill="none"></path>
      </svg>
    </button>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
import Swiper from 'swiper';

export default {
  name: 'GallerySlider',

  props: {
    images: {
      type: Array,
      required: true,
      validator(value) {
        return value.every(
          (item) => typeof item.src === 'string' && typeof item.alt === 'string'
        );
      }
    }
  },

  data() {
    return {
      swiperInstance: null
    };
  },

  mounted() {
    this.initSwiper();
  },

  beforeUnmount() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  },

  methods: {
    initSwiper() {
      if (!this.$refs.swiperContainer) return;

      this.swiperInstance = new Swiper(this.$refs.swiperContainer, {
        loop: true,
        effect: 'fade',
        grabCursor: false,
        speed: 500,
        slidesPerView: 1,
        allowTouchMove: false,

        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        },

        pagination: {
          el: '.swiper-pagination',
          clickable: false,
          dynamicBullets: true,
          dynamicMainBullets: 5,
        },

        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },

        autoplay: false,

        breakpoints: {
          0: {
            allowTouchMove: true,
          },
          768: {
            allowTouchMove: false,
          },
        },
      });
    }
  }
};
</script>
